const academic = [
  'Literature',
  'US History',
  'World History',
  'Math Level 1',
  'Math Level 2',
  'Biology — Ecological',
  'Biology — Molecular',
  'Chemistry',
  'Physics',
];

const languages = [
  'French',
  'French with Listening',
  'German',
  'German with Listening',
  'Spanish',
  'Spanish with Listening',
  'Modern Hebrew',
  'Italian',
  'Latin',
  'Chinese with Listening',
  'Japanese with Listening',
  'Korean with Listening',
];

export default [
  {
    label: 'Academic',
    options: academic.map((i) => ({ label: i, value: i })),
  },
  {
    label: 'Languages',
    options: languages.map((i) => ({ label: i, value: i })),
  },
];
